import React from "react";
import "./index.scss";

export default function Paragraph({text, className = ""}) {
    return <p className={className}>{text}</p>
}